// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ad-creative-thumb {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
}

.ad-creative-thumb.nexus-ad-tile__image {
  aspect-ratio: 16 / 9;
  min-height: 96px;
  max-height: 132px;
}

.ad-creative-thumb img {
  position: relative;
  z-index: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: var(--c-gray-1, #e2e8f0);
}

.ad-creative-thumb__badge {
  position: absolute;
  right: 6px;
  bottom: 6px;
  z-index: 1;
  padding: 2px 6px;
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--c-white);
  background: color-mix(in srgb, var(--c-black) 55%, transparent);
  border-radius: 3px;
  pointer-events: none;
}

.ad-creative-thumb__play {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
  border: none;
  background: color-mix(in srgb, var(--c-black) 22%, transparent);
  color: var(--c-white);
  cursor: pointer;
  pointer-events: auto;
  transition: background 0.15s ease;
}

.ad-creative-thumb__play:hover {
  background: color-mix(in srgb, var(--c-black) 38%, transparent);
}

.ad-creative-thumb__play-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: color-mix(in srgb, var(--c-black) 62%, transparent);
  box-shadow: 0 2px 8px color-mix(in srgb, var(--c-black) 35%, transparent);
}

.ad-creative-thumb__play-icon svg {
  fill: var(--c-white);
  stroke: var(--c-white);
  filter: drop-shadow(0 1px 2px color-mix(in srgb, var(--c-black) 40%, transparent));
}

.ad-creative-thumb__placeholder {
  width: 100%;
  height: 100%;
  min-height: 48px;
}

.ad-creative-thumb__placeholder--linkedin {
  background: linear-gradient(
    135deg,
    var(--c-blue-1) 0%,
    var(--c-blue-3) 55%,
    var(--c-blue-2) 100%
  );
}

.ad-creative-thumb__placeholder--meta {
  background: linear-gradient(
    135deg,
    var(--c-blue-2) 0%,
    var(--c-cyan-2) 50%,
    var(--c-blue-1) 100%
  );
}

.marketing-drawer-creative-wrap {
  width: 100%;
  aspect-ratio: 16 / 9;
  min-height: 140px;
  max-height: 220px;
  border-radius: 8px;
  border: 1px solid var(--border);
  overflow: hidden;
  background: var(--c-gray-1, #e2e8f0);
}

.marketing-drawer-creative-wrap .marketing-drawer-creative-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 140px;
  margin: 0;
  padding: 24px 16px;
  box-sizing: border-box;
  text-align: center;
  font-size: 13px;
  color: var(--text3);
}

.marketing-drawer-creative {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 140px;
}

.marketing-drawer-creative img {
  width: 100%;
  height: 100%;
  min-height: 140px;
  object-fit: cover;
  object-position: center top;
}

.marketing-drawer-creative--placeholder {
  min-height: 140px;
}

.marketing-drawer-creative--linkedin {
  background: linear-gradient(
    135deg,
    var(--c-blue-1) 0%,
    var(--c-blue-3) 55%,
    var(--c-blue-2) 100%
  );
}

.marketing-drawer-creative--meta {
  background: linear-gradient(
    135deg,
    var(--c-blue-2) 0%,
    var(--c-cyan-2) 50%,
    var(--c-blue-1) 100%
  );
}

.marketing-drawer-creative--google {
  background: linear-gradient(
    135deg,
    #e8f0fe 0%,
    #fce8e6 45%,
    #e6f4ea 100%
  );
}

.ad-creative-thumb__spinner-wrap {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  background: color-mix(in srgb, var(--c-white) 50%, transparent);
}

.ad-creative-thumb__spinner {
  width: 32px;
  height: 32px;
  border: 3px solid color-mix(in srgb, var(--c-blue-1) 20%, transparent);
  border-top-color: var(--c-blue-1);
  border-radius: 50%;
  animation: adCreativeSpin 0.8s linear infinite;
}

@keyframes adCreativeSpin {
  to { transform: rotate(360deg); }
}
`, "",{"version":3,"sources":["webpack://./src/components/mi/AdCreativeThumbnail.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,+DAA+D;EAC/D,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,+DAA+D;EAC/D,qBAAqB;EACrB,eAAe;EACf,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+DAA+D;EAC/D,yEAAyE;AAC3E;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kFAAkF;AACpF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE;;;;;GAKC;AACH;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,+DAA+D;AACjE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sEAAsE;EACtE,iCAAiC;EACjC,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC","sourcesContent":[".ad-creative-thumb {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n}\n\n.ad-creative-thumb.nexus-ad-tile__image {\n  aspect-ratio: 16 / 9;\n  min-height: 96px;\n  max-height: 132px;\n}\n\n.ad-creative-thumb img {\n  position: relative;\n  z-index: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background: var(--c-gray-1, #e2e8f0);\n}\n\n.ad-creative-thumb__badge {\n  position: absolute;\n  right: 6px;\n  bottom: 6px;\n  z-index: 1;\n  padding: 2px 6px;\n  font-size: 9px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--c-white);\n  background: color-mix(in srgb, var(--c-black) 55%, transparent);\n  border-radius: 3px;\n  pointer-events: none;\n}\n\n.ad-creative-thumb__play {\n  position: absolute;\n  inset: 0;\n  z-index: 3;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n  border: none;\n  background: color-mix(in srgb, var(--c-black) 22%, transparent);\n  color: var(--c-white);\n  cursor: pointer;\n  pointer-events: auto;\n  transition: background 0.15s ease;\n}\n\n.ad-creative-thumb__play:hover {\n  background: color-mix(in srgb, var(--c-black) 38%, transparent);\n}\n\n.ad-creative-thumb__play-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background: color-mix(in srgb, var(--c-black) 62%, transparent);\n  box-shadow: 0 2px 8px color-mix(in srgb, var(--c-black) 35%, transparent);\n}\n\n.ad-creative-thumb__play-icon svg {\n  fill: var(--c-white);\n  stroke: var(--c-white);\n  filter: drop-shadow(0 1px 2px color-mix(in srgb, var(--c-black) 40%, transparent));\n}\n\n.ad-creative-thumb__placeholder {\n  width: 100%;\n  height: 100%;\n  min-height: 48px;\n}\n\n.ad-creative-thumb__placeholder--linkedin {\n  background: linear-gradient(\n    135deg,\n    var(--c-blue-1) 0%,\n    var(--c-blue-3) 55%,\n    var(--c-blue-2) 100%\n  );\n}\n\n.ad-creative-thumb__placeholder--meta {\n  background: linear-gradient(\n    135deg,\n    var(--c-blue-2) 0%,\n    var(--c-cyan-2) 50%,\n    var(--c-blue-1) 100%\n  );\n}\n\n.marketing-drawer-creative-wrap {\n  width: 100%;\n  aspect-ratio: 16 / 9;\n  min-height: 140px;\n  max-height: 220px;\n  border-radius: 8px;\n  border: 1px solid var(--border);\n  overflow: hidden;\n  background: var(--c-gray-1, #e2e8f0);\n}\n\n.marketing-drawer-creative-wrap .marketing-drawer-creative-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 140px;\n  margin: 0;\n  padding: 24px 16px;\n  box-sizing: border-box;\n  text-align: center;\n  font-size: 13px;\n  color: var(--text3);\n}\n\n.marketing-drawer-creative {\n  display: block;\n  width: 100%;\n  height: 100%;\n  min-height: 140px;\n}\n\n.marketing-drawer-creative img {\n  width: 100%;\n  height: 100%;\n  min-height: 140px;\n  object-fit: cover;\n  object-position: center top;\n}\n\n.marketing-drawer-creative--placeholder {\n  min-height: 140px;\n}\n\n.marketing-drawer-creative--linkedin {\n  background: linear-gradient(\n    135deg,\n    var(--c-blue-1) 0%,\n    var(--c-blue-3) 55%,\n    var(--c-blue-2) 100%\n  );\n}\n\n.marketing-drawer-creative--meta {\n  background: linear-gradient(\n    135deg,\n    var(--c-blue-2) 0%,\n    var(--c-cyan-2) 50%,\n    var(--c-blue-1) 100%\n  );\n}\n\n.marketing-drawer-creative--google {\n  background: linear-gradient(\n    135deg,\n    #e8f0fe 0%,\n    #fce8e6 45%,\n    #e6f4ea 100%\n  );\n}\n\n.ad-creative-thumb__spinner-wrap {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n  background: color-mix(in srgb, var(--c-white) 50%, transparent);\n}\n\n.ad-creative-thumb__spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid color-mix(in srgb, var(--c-blue-1) 20%, transparent);\n  border-top-color: var(--c-blue-1);\n  border-radius: 50%;\n  animation: adCreativeSpin 0.8s linear infinite;\n}\n\n@keyframes adCreativeSpin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
